
import axios from '../env/axios'
import apis from '../env/apis'
import common from './common'
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
    data(){
        return {
            loading : false,
            wsuri: 'ws://138.2.16.125:8080/websocket/test', // ws wss
            socket: null,
            typeLists:[]
        }
    },
    methods : {
        /**
         * WebSocket
         */
        // initWebSocket() {
        //     try {
        //         if ('WebSocket' in window) {
        //             this.socket = new WebSocket(this.wsuri)
        //         } else {
        //             console.log('您的浏览器不支持websocket')
        //         }
        //         this.socket.onopen = this.websocketonopen
        //         this.socket.onerror = this.websocketonerror
        //         this.socket.onmessage = this.websocketonmessage
        //         this.socket.onclose = this.websocketclose
        //         this.$store.state.socket=this.socket
        //     } catch (e) {
        //         //this.reconnect()
        //     }
        // },
        // websocketonopen() {
        //     console.log('WebSocket连接成功', this.socket.readyState)
        //     //heartCheck.start(this.socket)
        //     // this.socket.send('发送数据')
        //     //this.websocketsend()
        // },
        // websocketonerror(e) {
        //     console.log('WebSocket连接发生错误', e)
        //     //this.reconnect()
        // },
        // websocketonmessage(e) {
        //     let data = JSON.parse(e.data);
        //     console.log(data)
        //     let { fromShop,shop,from,to,locationCode } = data;
        //     console.log(fromShop.split('-')[2])
        //     let fromShop1 = fromShop.split('-')[2];
        //     let shop1 = shop.split('-')[2];
        //     //获取登录地点-发送地点对比
        //     this.getUserLocation().then((res) => {
        //         console.log(res)
        //         console.log(locationCode)
        //         if(res == locationCode){
        //             this.$message(`${fromShop1}调整券号${from}-${to}到${shop1},请注意查收！`)
        //             // this.$alert(`${fromShop1}调整券号${from}-${to}到${shop1},请注意查收！`, '提示', {
        //             //     confirmButtonText: '确定',
        //             //     type: 'warning',
        //             //     center: true
        //             // })
        //         }
        //     })
        //     console.log('得到响应', data)
        // },
        // websocketclose(e) {
        //     console.log('connection closed (' + e.code + ')')
        // },
        // websocketsend() {
        //     let data = {id: 'a1b2c3'};
        //     //console.log("11"+this.socket)
        //     this.$store.state.socket.send(JSON.stringify(data))
        // },
        /**
         * 登录处理
         * @param {*} account 
         * @param {*} password 
         */
        checkLogin( account, password ,rememberPass ){
            let that = this;
            that.loading = true;
            axios.post(apis.baseURL, {
                act:"doLogin",
                userId:account,
                password:password
            })
            .then(function (res) {
                console.log(res);
                if(res.data.status == true){
                    debugger
                    console.log(res)
                    let {userLevel,locationCode,customerAppleP,phone} = res.data ;
                    if(customerAppleP=='null')customerAppleP='N'
                    sessionStorage.setItem('Token','111');
                    sessionStorage.setItem('userId',account);
                    sessionStorage.setItem('userLevel',userLevel);
                    sessionStorage.setItem('locationCode',locationCode);
                    sessionStorage.setItem("bigCus",customerAppleP);
                    sessionStorage.setItem("phone",phone);
                    if(rememberPass == '0'){
                        localStorage.removeItem('passWd')
                    }else{
                        localStorage.setItem('passWd', password);
                        localStorage.setItem('account', account);
                    }
                    let accessLevel = res.data.accessLevel;
                    accessLevel = accessLevel.split(',');
                    sessionStorage.setItem('treeId',JSON.stringify(accessLevel));
                    setTimeout(()=>{
                        that.loading = false;
                        //this.$router.push( { path : '/login' })
                        window.location.reload();    
                    },2000) 
                }else{
                    that.loading = false;
                    that.$alert('用户账号或密码错误', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    })
                }
            })
            .catch( function (error) {
                console.log(error)
                that.loading = false;
                that.$alert('请求不到数据或网络连接异常', '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    center: true
                })
            });
        },
        /**
         * 退出登录
         */
        logout(){
            this.$confirm("确定退出？",'提示',{
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            }) 
            .then(() => {
                sessionStorage.removeItem("Token");
                sessionStorage.removeItem("treeId");
                this.$router.push({path:'/login'});
                this.$store.state.socket.close();
            }) 
            .catch(() => {
            });    
        },
        /**
         * 加载所有用户信息
        */    
        async findAllUser(userId,level){
            let result ;
            let that =this ;
            await axios.post(apis.baseURL, {
                act:"findUsers",
                userId:userId || '',
                level
                
            })
            .then(function(res){
                if(res.data.status == true){
                    result = res.data.list
                }else{
                    that.$alert('加载失败', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    })
                }
                
            })
            .catch(function(error){
                console.log(error)
            })
            return result;
        },
        /**
         * @params type 页面
         * 查找产品类型
         */
        async findType(params){
            let result;
            await axios.post(apis.baseURL, params)
                .then( (res) => {
                    result = res ;
                })
                .catch( (error) => {
                    console.log(error)
                    this.loading = false;
                    this.$message({
                        showClose: true,
                        message: '请求不到数据或网络连接异常',
                        type: 'error'
                    });
                })
                return result;
        },
        /**
         * 获取删除数据 / 更新数据 / 增加
         */
        async delType(params){
            let result;
            await axios.post( apis.baseURL ,params)
                .then((res) => {
                    result = res ;
                })
                .catch( (error) => {
                    console.log(error)
                    this.$alert('请求不到数据或网络连接异常','提示',{
                        confirmButtonText:'确定',
                        type:'error',
                        center:true
                    });
                })
            return result;
        },

        /**
         * 保存成功（弹框）
         * msg:'更新成功/失败'
         * type:'error / success'
         */
        promptMsg(msg,type){
            this.$message({
                showClose: true,
                message: msg,
                type: type
            });
        },

        /**
         * 添加成功提示
        */
        confirmInfo(res,url){
            if(res.data.status == true){
                this.$confirm('你已添加成功，是否继续添加','提示',{
                    confirmButtonText: '继续添加',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(()=>{
                //确定 - 刷新表单
                    this.reload();
                }).catch(() => {
                //取消 - 跳转
                this.$router.push({ path: url})//跳转
                })
            }else{
                if(res.data.msg){
                    this.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        center: true
                    });
                }else{
                    this.$alert('添加失败', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        center: true
                    });
                }
            }
        },
        /*-------- 券号管理-------- */
        /**
         * 创建券号
        */
        // async createCoupon(params){
        //     let result;
        //     await axios.post(apis.baseURL,params)
        //         .then((res) => {
        //             result = res;
        //         })
        //         .catch( (error) => {
        //             this.$alert('请求不到数据或网络连接异常','提示',{
        //                 confirmButtonText:'确定',
        //                 type:'error',
        //                 center:true
        //             });
        //         })
        //     return result;
        // },
        /**
         * 下载管理
         * @param {*} msg 
         * @param {*} type 
        */
        // async downLoad3(params){
        //     let result;
        //     await axios.post(apis.baseURL,params)
        //         .then((res) => {
        //             console.log('xiazai')
        //             result = res;
        //         })
        //         .catch( (error) => {
        //             this.$alert('请求不到数据或网络连接异常','提示',{
        //                 confirmButtonText:'确定',
        //                 type:'error',
        //                 center:true
        //             });
        //         })
        //     return result;
        // },

        /**
         * 错误弹框提示
         * @param {string} msg 
         * @param {string} type 
         */
        alert(msg,type){
            this.$alert(msg, '提示', {
                confirmButtonText: '确定',
                type: type,
                center: true,
                callback: action =>{
                    return false;
                }
            });
        },

        /**
         * @param {*} type 
         */
        async loadTypes(act){
            let result;
            this.loading = true;
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act : act,
                userId
            }
            await axios.post(apis.baseURL, params)
                .then( (res) => {
                    if(res.data.status == true){
                        this.loading = false;
                        result = res.data.list;
                    }else{
                        this.loading = false;
                        this.promptMsg('加载失败','提示')
                    } 
                })
                .catch( (error) => {
                    console.log(error)
                    this.loading = false;
                    this.$message({
                        showClose: true,
                        message: '请求不到数据或网络连接异常',
                        type: 'error'
                    });
                })
                return result;
        },

        /**
         * 获取userID 地点code
         */
        async getUserLocation(){
            let result ;
            let userId = sessionStorage.getItem("userId") ;
            let userLevel = sessionStorage.getItem("userLevel") ;
            let params = {
                act : "findUsers",
                userId ,
                level : userLevel
            }
            await axios.post(apis.baseURL, params)
                .then( (res) => {
                    if(res.data.status == true && res.data.list.length>0){
                        this.loading = false;
                        result = res.data.list[0].locationCode;
                    }else if(res.data.status == false){
                        this.loading = false;
                        this.promptMsg('加载失败','提示')
                    } 
                })
                .catch( (error) => {
                    this.loading = false;
                    this.$message({
                        showClose: true,
                        message: '请求不到数据或网络连接异常',
                        type: 'error'
                    });
                })
                return result;
        },

        /**
         * 获取是否免费
         * @param {} code 
         */
        async getComply(){
           let a =  await this.getUserLocation();
           let b = await this.getLocationCom(a);
           return b ;
        },
        /**
         * @param {地点是否免费} code 
         */
        async getLocationCom(code){
            let result ;
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act : 'findLocations',
                userId
            }
            await axios.post(apis.baseURL, params)
                .then( (res) => {
                    console.log(res)
                    if(res.data.status == true){
                        this.loading = false;
                        let resultData = res.data.list;
                        let descriptionObj = resultData.find((elem) => elem.locationCode == code) ;
                            if(descriptionObj){
                                // result = descriptionObj.complimentary ;
                                result = descriptionObj ;
                            }else{
                                this.promptMsg('加载失败','提示')
                            }
                    }else{
                        this.loading = false;
                        this.promptMsg('加载失败','提示')
                    } 
                })
                .catch( (error) => {
                    this.loading = false;
                    this.$message({
                        showClose: true,
                        message: '请求不到数据或网络连接异常',
                        type: 'error'
                    });
                })
                return result;

        },

        /**
         * 根据地点code获取地点名称
         */
        async getLocationDes(code){
            
            let result ;
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act : 'findLocations',
                userId
            }
            await axios.post(apis.baseURL, params)
                .then( (res) => {
                    console.log(res)
                    if(res.data.status == true){
                       
                        this.loading = false;
                        let resultData = res.data.list;
                        let descriptionObj = resultData.find((elem) => elem.locationCode == code) ;
                        if(descriptionObj){
                            result = descriptionObj.description ;
                        }else{
                            this.promptMsg('加载失败','提示')
                        }
                    }else{
                        this.loading = false;
                        this.promptMsg('加载失败','提示')
                    } 
                })
                .catch( (error) => {
                    this.loading = false;
                    this.$message({
                        showClose: true,
                        message: '请求不到数据或网络连接异常',
                        type: 'error'
                    });
                })
                return result;

        },

        /**
         * 根据userId获取index
        */
        async getUserIndex(act,fn){
            let result ;
            let userId = sessionStorage.getItem("userId") ;
            await axios.post(apis.baseURL, {
                act  ,
                userId

            })
            .then(function(res){
                if(res.data.status == true){
                    let resultData = res.data.list ;
                    result = resultData.findIndex(fn)
                }else{
                    this.promptMsg('加载失败','提示')
                }  
            })
            .catch(function(error){
                this.promptMsg('请求不到数据或网络连接异常','提示')
            })
            return result;
            
        },
        /**
         * 加载中
         */
        loadingCommon(){
            const loading = this.$loading({
                lock: true,
                text: '系统正在处理中，请耐心等待 !',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            return loading;
        },

        /**
         * 处理批量激活/核销
         */
        handleAtive(params,text){
            this.loading = false;
            this.$confirm(`是否${text}券号 ${params.from} - ${params.to}`,'提示',{
                confirmButtonText:'确定',
                cancelButtonText :'取消',
                type : 'warning',
                center :true
            }).then(() =>{
                //验证是否可以核销
                let loading = this.loadingCommon();
                //获取地点
                this.delType(params).then((res) =>{
                    console.log(res)
                    let { status,errorData} = res.data ;
                    if(status == true && res.data.data.qty !== '0'){
                        loading.close();
                        this.$confirm(`${text}成功 ${res.data.data.qty}`,'提示',{
                            confirmButtonText : '确定',
                            showCancelButton : false ,
                            type : 'success'
                        }).then( () =>{
                            this.promptMsg(`${text}成功`,'success');
                            this.ruleForm = {
                                voucherCode:{
                                    value1:"",
                                    value2:""
                                },
                                locationCode:'',
                                complimentary:''
                            }
                            this.value9 = '' ;
                            this.reload();
                        }).catch(() => {
                            this.promptMsg('已取消','info');
                        })
                    }else if(res.data.status == true && res.data.data.qty == '0'){
                        loading.close();
                        this.$confirm(`${text}成功 ${res.data.data.qty}`, '提示', {
                                confirmButtonText: '确定',
                                showCancelButton :false ,
                                type: 'success'
                            }).then(() => {
                                this.alert(`${text}失败，请查看错误信息!`,'warning')
                                // for(let i = 0 ;i < errorData.length;i++){
                                //     errorData[i].status = that.formalStatus(errorData[i].status);
                                //     errorData[i].complimentary = 'null' ? '否' : '是' ;
                                // }
                                // that.errData = errorData ;
                                // this.$router.push({ path : '/ticket/manageList'});
                            }).catch((error) => {
                                this.promptMsg('已取消','info') ;

                            });
                    }else{
                        loading.close();
                        this.$alert(`${text}失败`,'提示') ;
                    }
                })
            }).catch(() =>{
                //loading.close();
                this.promptMsg('已取消','info')
            })
        },
        /**
         * 验证券
         */
        checkedRange(checkParams,params,text){
            let that = this ;
            that.loading = true ;
            that.delType(checkParams).then((res) =>{
                // console.log(res)
                let { status , errorData} = res.data ;
                let len = errorData.length ;
                if( status == true && len == 0 ){
                    //执行核销
                    that.handleAtive(params,text); //处理批量核销
                }else if(status == true && len > 0){
                    //显示错误
                    this.loading = false;
                    this.alert(`${text}失败,请查看错误信息!`,'warning');
                    for(let i = 0 ;i < errorData.length;i++){
                        errorData[i].status = that.formalStatus(errorData[i].status);
                        errorData[i].complimentary = 'null' ? '否' : '是' ;
                    }
                    that.errData = errorData ;
                }else{
                    this.$alert(`加载失败`,'提示') ;
                }
            })
        },
        /**
         * 销售管理-加载列表
        */
        refreshTypes(state){
            this.loading = true;
            let userId = sessionStorage.getItem("userId") ;
            this.getUserLocation().then((res) =>{
                this.loading = true;
                let code = res ;
                let params = {
                    act:'status1',
                    loc:code ,
                    userId
                } 
                this.findType(params).then((res) =>{
                    if(res.data.status == true){
                        // this.loading = false;
                        let result = res.data.report ;
                        let params1 = {
                            act:'findTypes',
                            userId
                        }
                        let resultObj = result.filter((elem) =>{
                            return elem.status == state
                        })
                        this.findType( params1 ).then((res) =>{
                            if(res.data.status == true){
                                // this.loading = false ;
                                let typesResult = res.data.list ;
                                typesResult.forEach((elem,i) =>{
                                    elem.qty = 0 ;
                                    resultObj.forEach((elem1,i1) =>{
                                        if(elem1.code == elem.typeCode){
                                            elem.qty = this.changeTree(elem1.qty) ;  //转换千分位 
                                        }
                                    })
                                })
                                let unAmount = this.unTotalTicket(resultObj) ;//未销售、核销
                                this.loading = false;
                                this.unAmount = unAmount ;
                                this.tableData3 = typesResult;
                            }else{
                                this.loading = false ;
                                this.promptMsg('加载失败','info');
                            }
                        })
                    }
                })
            })
        },
        /**
         * 券号管理
         */
        refreshTypes2(state){
            this.loading = true;
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'status1',
                userId
            } 
            this.findType(params).then((res) =>{
                console.log(res)
                this.loading = true;
                if(res.data.status == true){
                    let result = res.data.report ;
                    let params1 = {
                        act:'findTypes',
                        userId
                    }
                    let resultObj = result.filter((elem) =>{
                        return elem.status == state
                    })
                    this.findType( params1 ).then((res) =>{
                        if(res.data.status == true){
                            // this.loading = false ;
                            let typesResult = res.data.list ;
                            typesResult.forEach((elem,i) =>{
                                elem.qty = 0 ;
                                resultObj.forEach((elem1,i1) =>{
                                    if(elem1.code == elem.typeCode){
                                        elem.totalGeneratedQty = this.changeTree(elem.totalGeneratedQty)
                                        elem.qty = this.changeTree(elem1.qty) ;  
                                    }
                                })
                            })
                            let unAmount = this.unTotalTicket(resultObj) ;//未销售、核销
                            this.unAmount = unAmount ;
                            this.loading = false ;
                            this.tableData3 = typesResult;
                        }else{
                            this.loading = false ;
                            this.promptMsg('加载失败','info');
                        }
                    })
                }
            })
        },
        //获取当前时间
        getTime(){
            var date = new Date();
            var year = date. getFullYear();
            var month = date.getMonth()+1;//获取月
            var day = date.getDate(); //获取当日
            if(month >= 1 && month <=9){
                month = "0" + month;
            }
            if(day >= 1 && day <=9){
                day = "0" + day;
            }
            var time = year+"-"+month+"-"+day; //组合时间  
            return time;   
        },
        //下载列表
        downLoad(name){
            /* 从表生成工作簿对象 */
            debugger
            var xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
            console.log(xlsxParam);
            var wb = XLSX.utils.table_to_book(document.querySelector("#Console"), xlsxParam);
           console.log(wb);
            /* 获取二进制字符串作为输出 */
            var wbout = XLSX.write(wb, {
                bookType: "xlsx",
                bookSST: true,
                type: "array"
            });
            var date = this.getTime();
            
            try {
                FileSaver.saveAs(
                //Blob 对象表示一个不可变、原始数据的类文件对象。
                //Blob 表示的不一定是JavaScript原生格式的数据。
                //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                new Blob([wbout], { type: "application/octet-stream" }),
                //设置导出文件名称
                `${date} ${name}.xlsx`
                );
            } catch (e) {
                if (typeof console !== "undefined") console.log(e, wbout);
            }
            return wbout;
        },
        /**
         * 防抖
         * @param {} fn 
         * @param {*} wait 
         */
        debounce(fn, wait) {
            var timeout = null;    
            return function() { 
                if(timeout !== null)   clearTimeout(timeout);        
                timeout = setTimeout(fn, wait);    
            }
        },

        //table为空不下载
        isDownTable(tableData,fn,args1){
            if(tableData == ''){
                this.alert('没有数据','warning')
            }else{
                fn.call(this,args1) ;
            }
        },

        loadingArea(){
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findLocations',
                userId
            }
            return new Promise((resolve,reject) => {
                this.findType(params).then( (res) => {
                    var {status} = res.data ;
                    if(status){
                        var {list:result}  = res.data;
                        let location = result.map( (elem, index, arr) => {
                            return { value : elem.locationCode ,label:elem.description }
                        })
                        resolve(location)
                    }else{
                        this.promptMsg('加载失败!','info')
                    }
                }).catch((error) => {
                    reject(error)
                })
            })
        },


        dialogCancel(){
            let that = this;
            //取消
            that.centerDialogVisible = false;
            clearInterval(timer);
            clearInterval(timer1);
        },
        dialogNoCancel(){
            let that = this;
            that.centerDialogVisible = false;
            clearInterval(timer);
            clearInterval(timer1);
        },
        //关闭
        close(){
            let { orderNo, userId } = this.$route.query;
            this.centerDialogVisible = false;
            clearInterval(timer);
            clearInterval(timer1);
            this.reload();
            this.getDetailsList(orderNo, userId)
      
        },
        //监听剩余时间
        getCheckOrderTime (orderNo, userId) {
            let that = this;
            let params = {
                act: 'checkOrderTime',
                orderNo,
                userId
            }
            let orderTimePromise = new Promise((resolve, reject) => {
                that.delType(params).then((res) => {
                    resolve(res)
                }).catch((error) => {
                    console.log(error)
                })
            })
            return orderTimePromise;

        },

        //是不是财务账号
        isTrueAccount(userId){
            let that = this;
            let userLevel = sessionStorage.getItem("userLevel") ;
            if(userId == "SHFD01" || userId == "HBFD01" || userId == 'HNFD01' || userId == 'JENNIE' || userId == 'SYSADMIN'|| userLevel == 'A'){
                that.clearable = true ;
                that.disabled = false ;
            }else{
                console.log('不是财务账号')
                that.clearable = false ;
                that.disabled = true ;
            }

        },
    }
}